export class Parametros {
	valorMinimoBoleto: number = 0;
	valorTaxaBoleto: number = 0;
	datasVencimento: Date[];
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/collection/models/parametros.ts